import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'descSlice', pure: false })

export class DescSlicePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: any, length?: number): any {
    if ((value === null) || (value === '')) {
      return '';
    } else {
      length = (length === null || length === 0 || length === undefined) ? 20 : length;
      if (value.length <= length) {
        return value;
      }
      value = value.replace(/<(?:.|\n)*?>/gm, ' ');
      return value.substring(0, length) + '...';
    }
  }
}
